"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MeetingAgendaItemStatusSchema () {
        return MeetingAgendaItemStatusSchema;
    },
    get MeetingAgendaItemsSchema () {
        return MeetingAgendaItemsSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const MeetingAgendaItemStatusSchema = _zod.z.union([
    _zod.z.literal("complete"),
    _zod.z.literal("incomplete"),
    _zod.z.literal("deleted")
]).default("incomplete");
/**
 * Represents a meeting associated with an agenda item and its status.
 * Agenda items can roll over and be associated with multiple meetings.
 * Providing the status at the meeting level allows for tracking the progress
 * of the agenda item across multiple meetings.
 **/ const MeetingWithAgendaItemStatusSchema = _zod.z.object({
    /** Foreign key - meeting document */ meeting_id: _zod.z.instanceof(_bson.ObjectId),
    status: MeetingAgendaItemStatusSchema,
    /** Display order within this meeting; absent until the list is first reordered */ position: _zod.z.number().int().nonnegative().optional()
});
const MeetingAgendaItemsSchema = _base.BaseDocument.extend({
    name: _zod.z.string(),
    meetings: _zod.z.array(MeetingWithAgendaItemStatusSchema),
    goal_id: _zod.z.instanceof(_bson.ObjectId).nullable().optional(),
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord
});
